import {GET_LIVE_REPORTS_SUCCESS} from "../../../reducers/dashboardReducer";



export const getLiveReportsSuccess = (liveReports) =>{
    return {
        type: GET_LIVE_REPORTS_SUCCESS,
        payload: {liveReports}
    }
}